<template>
    <v-dialog v-model="show" no-click-animation persistent width="500">
        <v-card>
            <v-layout class="headline grey lighten-2 pl-3 pr-2 py-2" primary-title align-center>
                <div>{{item ? $t('creator.keyword') : $t('editor.keyword')}}</div>
                <v-spacer></v-spacer>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <v-card-text>
                <v-form v-model="formValid" @submit="submit" ref="form">
                    <v-autocomplete
                        :label="$t('entity') | capitalize"
                        v-model="entity"
                        :items="entityList"
                        item-text="label"
                        item-value="label"
                        :disabled="!!item"
                        :rules="formRules.required"
                    ></v-autocomplete>
                    <v-text-field
                        :label="$t('keyword') | capitalize"
                        v-model="keyword"
                        :disabled="!!item"
                        :rules="formRules.required"
                    ></v-text-field>
                    <v-text-field
                        :label="$t('synonym') | capitalize"
                        v-model="synonym"
                    ></v-text-field>
                    <v-layout wrap class="synonym-container">
                        <v-layout align-center v-for="(synonymItem, i) in synonymList" :key="i" class="synonym">
                            {{synonymItem}}
                            <v-icon small @click="removeSynonym(i)">mdi-close</v-icon>
                        </v-layout>
                    </v-layout>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-0" type="submit">{{ $t('save') }}</v-btn>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import lodash from 'lodash'
import NLP_Service from "@/services/nlp.service";
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import { mapState } from "vuex";

export default {
    name: "KeywordEditor",
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            item: null,
            entity: '',
            keyword: '',
            synonym: '',
            synonymList: []
        }
    },
    computed:{
        ...mapState({
            entityList: state => state.scenario.entityList
        })
    },
    methods: {
        open (item) {
            this.item = item
            if (this.item) {
                this.entity = item.entity_label
                this.keyword = item.value
                this.synonymList = [...item.synonym]
            } else {
                this.clearForm()
                this.meaningList = []
                this.synonymList = []
            }
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        submitValidForm () {
            let synonymList = this.synonymList
            if (this.synonym) {
                synonymList = this.synonym
                    .split(';')
                    .filter(item => !!item)
                    .map(item => item.trim())
                    .concat(this.synonymList)
                synonymList = lodash.uniqBy(synonymList, item => item)
            }
            let model = {
                value: this.keyword,
                synonym: JSON.stringify(synonymList)
            }
            let i18n, promise
            if (this.item) {
                i18n = {
                    action: this.$t('update'),
                    item: this.$t('keyword')
                }
                promise = NLP_Service.KeywordService.replace(
                    this.$route.params.scenarioId,
                    this.item.entity_label,
                    this.item.code,
                    model
                )
            } else {
                i18n = {
                    action: this.$t('create'),
                    item: this.$t('keyword')
                }
                promise = NLP_Service.KeywordService.create(
                    this.$route.params.scenarioId,
                    this.entity,
                    model
                )
            }

            this.$appService.showLoading()
            promise.then(
                result => {
                    this.close()
                    this.$appService.handleRequestError(this.$t('actionSuccessful', i18n))
                    this.promise.resolve(result.data)
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
            this.clearForm()
        },
        removeSynonym(index) {
            this.synonymList.splice(index, 1)
        }
    }
}
</script>

<style scoped lang="scss">
    .synonym-container {
        .synonym {
            background: blue;
            color: #fff;
            border-radius: 5px;
            padding: 5px;
            margin: 0 5px 5px 0;
            flex-grow: 0;

            &::v-deep i {
                background: #fff;
                margin-left: 5px;
                border-radius: 100%;
            }
        }
    }
</style>
